import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Card from '../../../shared/Card';
import { formatDistanceToNow } from 'date-fns';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import {
  postTeamChartEmbedUsingTeamidAndChartid,
  postTeamTableEmbedUsingTeamidAndTableid
} from 'api/cloudApiGenerated';
import { sendPayload } from '../helpers/ProjectsPageHelper';

const data = {
  1: {
    icon: '/static/images/donut.svg',
    name: 'chart'
  },
  2: {
    icon: '/static/images/donut.svg',
    name: 'chart'
  },
  3: {
    icon: '/static/images/map.svg',
    name: 'map'
  },
  4: {
    icon: '/static/images/smallmultiple.png',
    name: 'layout'
  },
  5: {
    icon: '/static/images/table.png',
    name: 'table'
  }
};

export default function Project(props) {
  const selectedSort = useSelector((state) => state.chartsPage.selectSortValue);
  const { team } = useSelector((state) => state.profile);

  const [loadingEmbed, setLoadingEmbed] = useState(false);
  const [loadingEmbedStatus, setLoadingEmbedStatus] = useState({
    loading: false,
    done: false
  });

  const [loadingLink, setLoadingLink] = useState(false);
  const [loadingLinkStatus, setLoadingLinkStatus] = useState({
    loading: false,
    done: false
  });

  const placeholder = data[props.chart.chart_type];
  const editChart = () => {
    return;
  };

  const thumbnailURL = props.chart.thumbnail_url;

  const templateTimeSinceLastChange = () => {
    const [created, edited] = [props.chart.creation_time, props.chart.last_updated].map((x) =>
      formatDistanceToNow(new Date(x))
    );

    const lastAction = [
      { text: 'edited', pick: edited !== created, value: edited },
      { text: 'created', pick: Boolean(created), value: created }
    ].find((x) => x.pick === true);

    return selectedSort.id === 0
      ? `${lastAction.text} ${lastAction.value} ago by ${props.chart.username}`
      : `created ${created} ago by ${props.chart.creator}`;
  };

  const publishChart = async () => {
    await (props.chart.chart_type === 5
      ? postTeamTableEmbedUsingTeamidAndTableid
      : postTeamChartEmbedUsingTeamidAndChartid)(team.id, props.chart.id);
  };

  const useChart = (useLink) => {
    sendPayload(props.chart, useLink);
  };

  const onClickEmbedBtn = async () => {
    setLoadingEmbedStatus((prev) => ({ ...prev, loading: true }));
    if (props.chart.has_published === 0) {
      if (loadingEmbed) return;
      setLoadingEmbed(true);
      await publishChart();
      setLoadingEmbed(false);
      props.updateProject(props.chart, { has_published: 1 });
      useChart();
    } else {
      useChart();
    }
    setTimeout(() => setLoadingEmbedStatus(() => ({ loading: false, done: true })), 500);
    setTimeout(() => setLoadingEmbedStatus(() => ({ loading: false, done: false })), 1000);
  };

  const onClickLinkBtn = async () => {
    setLoadingLinkStatus((prev) => ({ ...prev, loading: true }));
    if (props.chart.has_published === 0) {
      if (loadingLink) return;
      setLoadingLink(true);
      await publishChart();
      setLoadingLink(false);
      props.updateProject(props.chart, { has_published: 1 });
      useChart(true);
    } else {
      useChart(true);
    }
    setTimeout(() => setLoadingLinkStatus(() => ({ loading: false, done: true })), 500);
    setTimeout(() => setLoadingLinkStatus(() => ({ loading: false, done: false })), 1000);
  };

  const notPublished = props.chart.has_published === 0 || props.chart.has_published === null;

  return (
    <Card
      title={props.chart.name}
      thumbnail={thumbnailURL}
      hideHoverDescriptor={false}
      highlighted={props.highlighted}
      href={({ ...ps }) => (
        <a {...ps} href={editChart()}>
          {ps.children}
        </a>
      )}
      placeholder={placeholder}
    >
      {<span className="text-gray-500 text-xs h-8">{templateTimeSinceLastChange()}</span>}
      {/*tags*/}

      <div className="pt-2">
        {props.chart.has_published === 1 && (
          <div className="flex gap-1">
            <PrimaryButton
              className="w-[40px]"
              tooltip={'Public link'}
              useLoader={{
                default: {
                  text: '',
                  icon: 'link'
                },
                loading: {
                  text: '',
                  check: loadingLinkStatus.loading
                },
                done: {
                  text: '',
                  icon: 'circle-check',
                  check: loadingLinkStatus.done
                }
              }}
              text={''}
              onClick={onClickLinkBtn}
              buttonType={ButtonType.Circle}
              buttonColor={ButtonColor.NavyBlue}
            />

            <PrimaryButton
              className="w-[40px]"
              tooltip={'Embed code'}
              useLoader={{
                default: {
                  text: '',
                  icon: 'code'
                },
                loading: {
                  text: '',
                  check: loadingEmbedStatus.loading
                },
                done: {
                  text: '',
                  icon: 'circle-check',
                  check: loadingEmbedStatus.done
                }
              }}
              text={''}
              onClick={onClickEmbedBtn}
              buttonType={ButtonType.Circle}
              buttonColor={ButtonColor.NavyBlue}
              loaderClass={'bg-red'}
            />
          </div>
        )}
        {notPublished && (
          <PrimaryButton
            className="w-full"
            text={<>{loadingEmbed && <i className="fa fa-spinner fa-spin" />} Publish and copy</>}
            onClick={onClickEmbedBtn}
            buttonColor={ButtonColor.Yellow}
          />
        )}
      </div>
    </Card>
  );
}
